import { VehicleTransferSearchFormValues } from "./types";

export const initialVehicleTransferSearchForm: VehicleTransferSearchFormValues = {
  search: "",
  locationType: null,
  validFromFrom: null,
  validFromTo: null,
  isActive: null,
};
